import React, { Component } from 'react';
import { Grid, Container, Divider, Tab, Checkbox } from 'semantic-ui-react';
import { PtInput, PtInputIcon, PtSelect, EditGeographicPoint } from '../grit-utilities';
import 'semantic-ui-css/semantic.min.css';
import '../index.css';
import ImageGallery from './image-gallery';

export default class VRIC extends Component {

    constructor(props) {
        super(props);
        if (this.props.loadData) {
            this.state = this.props.loadData;
            // console.log('data was loaded from server');
            //console.log(this.state);
        }
        else {
            // This is a super data model class, its main function is to collect data from all the children components.
            this.state = {
                layer: 5,
                layerName: 'VRIC',
                layerId: -1,
                agencyId: -1, //to be determined later
                point: '0,0',

                advisoryType: 3,
                advisorySpeed: 0,
                hwyLegalSpeed: 0,
                enabled: true,
                signFacingDirection: 0

            };
        }

        this.panes = [
            {
                menuItem: 'Sign', render: () =>
                    <Tab.Pane>
                        {this.renderPointTab()}
                    </Tab.Pane>
            }
        ];

        this.props.dataModel.splice(0, this.props.dataModel.length);
        this.props.dataModel.push(this.state);


        //this.state = this.props.pointModel;
    }

    render() {
        return (
            <div>
                {/* <Grid.Row>
                    <h5>Virtual Image Capture</h5>
                </Grid.Row> */}
                <Divider style={{ marginTop: -3 }} />
                <Grid.Row>
                    <Tab panes={this.panes} activeIndex={this.props.activeIndex} onTabChange={this.onTabChange} />
                </Grid.Row>
                {typeof this.props.VRICPhotos !== 'undefined' && this.props.VRICPhotos.photos !== 'undefined' && this.props.VRICPhotos.photos.length > 0 ? (
                    <div>
                        <Divider/>
                        <Tab.Pane>
                            <ImageGallery 
                             photos={this.props.VRICPhotos.photos} 
                             UpdateVRICPhotos={this.props.UpdateVRICPhotos} />
                        </Tab.Pane>
                    </div>
                ) : null}
            </div>
        );

    }

    renderPointTab() {
        const { onClickSinglePoint } = this.props.clickFunctions;
        //const {onClickPoint} = this.props.clickFunctions;

        const pointState = (pos) => {
            const point = `${pos.lat.toFixed(5)}, ${pos.lng.toFixed(5)}`;
            this.setState({ point: point });
        };

        const advisoryTypes = [
            { key: 3, label: "Virtual Image Capture", value: 3, isSelected: false },
            { key: 0, label: "Curve Warning", value: 0, isSelected: false },
            { key: 1, label: "Bump", value: 1, isSelected: false },
            { key: 2, label: "Speed Zone", value: 2, isSelected: false }
        ];

        const directions = [
            { key: 0, label: "N", value: 0, isSelected: false },
            { key: 1, label: "S", value: 1, isSelected: false },
            { key: 2, label: "E", value: 2, isSelected: false },
            { key: 3, label: "W", value: 3, isSelected: false },
            { key: 4, label: "NE", value: 4, isSelected: false },
            { key: 5, label: "NW", value: 5, isSelected: false },
            { key: 6, label: "SE", value: 6, isSelected: false },
            { key: 7, label: "SW", value: 7, isSelected: false }

        ];

        return (
            <Container>

                <PtInputIcon inputColor="pt-intent-primary" disabled={this.props.disabled}
                    icon={<a className="grow pt-icon pt-icon-map-marker"
                        onClick={() => {
                            onClickSinglePoint(pointState);
                            this.props.triggerNeedSave();
                        }}
                        style={{
                            color: '#2385C1'
                        }}></a>}
                    value={this.state.point}
                    label="Geographic Location"
                    edit={<EditGeographicPoint originalCoords={this.state.point} updateCoordinate={(cp) => { onClickSinglePoint(pointState, cp); this.props.triggerNeedSave(); }} />} />

                <PtSelect name="advisoryType" label="Advisory Type" options={advisoryTypes} defaultVal={this.state.advisoryType} disabled={this.props.disabled} onChange={this.onChangeDropdown} />

                {this.state.advisoryType !== 3 ? (
                    <div>
                        <PtInput name="advisorySpeed" label="Advisory Speed" value={this.state.advisorySpeed} disabled={this.props.disabled} onChange={this.onInputChange} placeHolder="speed" type="number" />
                        <PtInput name="hwyLegalSpeed" label="Highway Legal Speed" value={this.state.hwyLegalSpeed} disabled={this.props.disabled} onChange={this.onInputChange} placeHolder="speed" type="number" />

                        <PtSelect name="signFacingDirection" label="Sign Facing Direction" options={directions} defaultVal={this.state.signFacingDirection} disabled={this.props.disabled} onChange={this.onChangeDropdown} />
                    </div>
                ) : null }
                <Checkbox toggle label='Enabled' onChange={() => { this.setState({ enabled: !this.state.enabled }) }} checked={this.state.enabled} />
            </Container>
        );
    }

    onChangeDropdown = (e) => {
        const { target } = e;
        const { name, value } = target;
        this.props.triggerNeedSave();
        // eslint-disable-next-line
        this.setState({ [name]: parseInt(value) });
    }

    onInputChange = (e) => {
        const { name, value } = e.target;
        this.props.triggerNeedSave();
        this.setState({ [name]: value });
    }

    componentDidUpdate() {
        //console.log(this.state);
        this.props.dataModel[0] = this.state;
    }
}


// WEBPACK FOOTER //
// ./src/layers/vric.js